import React from 'react';
import { TopbarContainer } from '../../containers';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { injectIntl } from '../../util/reactIntl';
import {
    Page,
    LayoutSideNavigation,
    LayoutWrapperMain,
    LayoutWrapperSideNav,
    LayoutWrapperTopbar,
    LayoutWrapperFooter,
    Footer,
    Impressum,
} from '../../components';

import css from '../TermsOfServicePage/TermsOfServicePage.css';
import { getLegalNotesTabs } from './getLegalNotesTabs';

const ImpressumPageComponent = ({ intl, scrollingDisabled }) => {
    const siteTitle = 'Impressum';
    const schemaTitle = intl.formatMessage({ id: 'PrivacyPolicyPage.schemaTitle' }, { siteTitle });

    const schema = {
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
    };

    const tabs = getLegalNotesTabs({ selectedPage: 'ImpressumPage' });

    return (
        <Page title={'Impressum'} schema={schema} scrollingDisabled={scrollingDisabled}>
            <LayoutSideNavigation>
                <LayoutWrapperTopbar>
                    <TopbarContainer currentPage="ImpressumPage" />
                </LayoutWrapperTopbar>
                <LayoutWrapperSideNav tabs={tabs} />
                <LayoutWrapperMain>
                    <div className={css.content}>
                        <h1 className={css.heading}>
                            <span>Impressum</span>
                        </h1>
                        <Impressum />
                    </div>
                </LayoutWrapperMain>
                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSideNavigation>
        </Page>
    );
};
const mapStateToProps = state => {
    return {
        scrollingDisabled: isScrollingDisabled(state),
    };
};

const ImpressumPage = compose(injectIntl, connect(mapStateToProps))(ImpressumPageComponent);

export default ImpressumPage;
